var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkles768(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4004 19.7654C24.2633 18.7904 21.7403 19.7325 20.7653 21.8696C19.7903 24.0068 20.7324 26.5297 22.8696 27.5047C25.0068 28.4797 27.5297 27.5376 28.5047 25.4005C29.4797 23.2633 28.5376 20.7404 26.4004 19.7654Z",
    fill: "#3897FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9592 46.1242L25.1329 53.4179L31.18 57.6616L23.8863 58.8353L19.6426 64.8824L18.4685 57.5889L12.4218 53.345L19.7155 52.1713L23.9592 46.1242Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3992 14.8071L54.3977 20.2467L61.7821 20.4564L56.3421 25.4549L56.1328 32.8394L51.1343 27.3997L43.7498 27.19L49.1893 22.1917L49.3992 14.8071Z",
    fill: "#00A98F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles768);
export default __webpack_public_path__ + "static/media/sparkles768.a31b777eb15a7310cf53e777ebe4d7d2.svg";
export { ForwardRef as ReactComponent };